<template>
  <div id="header_main" class="header">
    <div class="box clearfix">
      <router-link to="/" class="fl logo">
        <div id="logoImg" class="header_img1">
        </div>
      </router-link>
      <div class="nav fl">
        <ul>
          <li>
            <router-link to="/about" active-class="active" exact>关于我们</router-link>
          </li>
          <li><router-link to="/solution" active-class="active" >解决方案</router-link></li>
          <li><router-link to="/technicalService" active-class="active">技术服务</router-link></li>
          <li><router-link to="/trends" active-class="active">新闻中心</router-link></li>
          <li><router-link to="/employs" active-class="active">招贤纳士</router-link></li>
          <li><router-link to="/contact" active-class="active">联系我们</router-link></li>
        </ul>
      </div>
      <div class="fr el-icon-phone-outline"> 服务热线 <span style="color: #8FC31F;">{{ fphone }}</span></div>
    </div>
  </div>
</template>

<script>
  import axios from '../../../static/js/commonAxios'
  export default {
    name: "kheader",
    data(){
      return{
        active: false,
        imageUrl:'',
        fphone: '',
      }
    },
    mounted(){
      // this.baseUrl = process.env.API_ROOT;
      // this.getLogo()
      this.getTelPhone()
    },
    methods: {
      getLogo() {
        axios.get(`/api/logo`).then((res) => {
          if (res.data.success) {
            this.imageUrl = this.baseUrl + res.data.items[0].flogoUrl
          } else {
            this.$message({
              type: 'warning',
              message: res.data.msg
            });
          }
        });
      },
      getTelPhone(){
        axios.get('/api/selectContactUsContent').then((res) => {
          if(res.data.success){
            this.fphone = res.data.items[0].fphone
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },
      scroll() {
        if($(window).scrollTop() > 0) {
          $('#header_main').removeClass()
          $('#header_main').addClass('header_copy')
        } else {
          $('#header_main').removeClass()
          $('#header_main').addClass('header')
        }
      }
    },
  }
</script>

<style scoped>
  @keyframes example {
    0%   {background-color: #fff;}
    25%  {background-color: transparent;}
  }
  @keyframes example1 {
    0%   {background-color: transparent;}
    25%  {background-color: #fff;}
  }
  .header{
    position: fixed;
    top: 0;
    z-index: 9999;
    width: 100%;
    height: 72px;
    background: transparent;
    animation-name: example;
    animation-duration: 1s;
    overflow: hidden;
  }
  .header .logo{
    display: block;
  }
  .header .logo .header_img1 {
    background: url(../../assets/h-img1.png) no-repeat left center;
  }
  .header .nav{
    margin-left: 108px;
  }
  .header .nav li{
    width: 64px;
    line-height: 72px;
    text-align: center;
    float: left;
    margin-right: 45px;
  }
  .header .nav li a{
    display: block;
    width: 100%;
    font-size: 16px;
    color: #FEFEFE;
    border-bottom: 2px solid transparent;
    height: 70px;
    text-decoration: none;
  }
  .header .nav li a:hover{
    border-color: #fff;
    text-decoration: none;
  }
  .header .nav li a.active{
    border-color: #fff;
    text-decoration: none;
  }
  .header .fr{
    margin-right: 30px;
    line-height: 72px;
    color: #fff;
    font-size: 14px;
    padding-left: 20px;
    /*background: url(../../assets/1.png) no-repeat left center;*/
  }
  .header .fr span{
    font-size: 22px;
    color: #8ec31f;
    margin-left: 5px;
  }


  .header_copy{
    position: fixed;
    top: 0;
    z-index: 9999;
    width: 100%;
    height: 72px;
    background: #fff;
    animation-name: example1;
    animation-duration: 1s;
    overflow: hidden;
  }
  .header_copy .logo{
    display: block;
  }
  .header_copy .logo .header_img1 {
    background: url(../../assets/h-img2.png) no-repeat left center;
  }
  .header_copy .nav{
    margin-left: 108px;
  }
  .header_copy .nav li{
    width: 64px;
    line-height: 72px;
    text-align: center;
    float: left;
    margin-right: 45px;
  }
  .header_copy .nav li a{
    display: block;
    width: 100%;
    font-size: 16px;
    color: #36395a;
    border-bottom: 2px solid transparent;
    height: 70px;
    text-decoration: none;
  }
  .header_copy .nav li a:hover{
    border-color: #1E56C3;
    text-decoration: none;
  }
  .header_copy .nav li a.active{
    border-color: #1E56C3;
    text-decoration: none;
  }
  .header_copy .fr{
    margin-right: 30px;
    line-height: 72px;
    color: #36395a;
    font-size: 14px;
    padding-left: 20px;
    /*background: url(../../assets/1.png) no-repeat left center;*/
  }
  .header_copy .fr span{
    font-size: 22px;
    color: #8ec31f;
    margin-left: 5px;
  }
  #logoImg {
    height: 30px;
    width: 146px;
    margin-top: 19px;
  }
</style>



// WEBPACK FOOTER //
// src/components/kheader/kheader.vue